var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: { title: _vm.title, subtitle: _vm.subtitle, size: "sm" },
      on: {
        close: function($event) {
          _vm.$emit("close")
        }
      }
    },
    [
      _c("template", { slot: "footer" }, [
        _c(
          "button",
          {
            staticClass: "btn bg-purple-outline",
            on: {
              click: function($event) {
                _vm.$emit("close")
              }
            }
          },
          [_vm._v("fechar")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn bg-purple",
            class: { "btn--loading": _vm.preloader },
            on: {
              click: function($event) {
                _vm.$emit("confirmed")
              }
            }
          },
          [_c("span", [_vm._v("Deletar")])]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b49aef0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b49aef0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Confirmation.vue
// module id = null
// module chunks = 